export default __webpack_public_path__ + "static/media/typography.b27e3343.jpg";